enum CarRentalSourceEnum {
  EXTERNAL = 'extern',
  INTERNAL = 'intern'
}

export default CarRentalSourceEnum;
